import { Component, Prop, h, Host, Element, State, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'dda-search-input',
  styleUrls: [],
  shadow: false,
})
export class DdaSearchInput {
  @Prop() placeholder: string = 'Search';
  @Prop() label: string;
  @Prop() size: string = 'sm';
  @Prop() error_message: string;
  @Prop() show_button: boolean = false;
  @Prop() helper_text: string;
  @Prop() validation_id: string;
  @Prop() input_status?: string;
  @Prop() has_error: boolean = false;
  @Prop() custom_class?: string = '';
  @Prop() component_mode?: string;
  @Prop() button_id?: string;
  @Prop() input_id?: string;
  @Prop() aria_label?: string;
  @Prop() button_aria_label?: string;
  @Prop() search_input_name: string;
  @Prop() close_button_name: string;
  @Prop() search_button_name: string;
  @Prop() button_text: string;
  @Prop() value: string;

  @Event() inputChanged: EventEmitter<any>;
  @Event() buttonClicked: EventEmitter<any>;
  @Event() inputBlurred: EventEmitter<{ name: string; value: string }>;

  @Element() el: HTMLElement;

  @State() hasInputValue: boolean = false;
  @State() internalValue: string = '';

  handleInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    this.hasInputValue = target.value.length > 0;
  };

  handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      const target = event.target as HTMLInputElement;
      console.log('Search input value (Enter):', target.value);
    }
  };

  handleSearchClick = () => {
    const input = this.el.querySelector(`#${this.input_id}`) as HTMLInputElement;
    if (input) {
      // console.log('Search input value (Button):', input.value);
      this.buttonClicked.emit(this.internalValue || this.value);
    }
  };

  clearInput() {
    if (!this.input_id) return;
    const input = this.el.querySelector(`#${this.input_id}`) as HTMLInputElement;
    if (input) {
      input.value = '';
      this.hasInputValue = false;
      input.focus();
    }
  }

  render() {
    return (
      <Host>
        <div
          class={`dda-input-container dda-input-size-${this.size} ${this.component_mode} ${this.custom_class} ${this.input_status ? `dda-input-${this.input_status}` : ''} ${this.has_error ? 'dda-validation-error' : ''}`}
        >
          {this.label && (
            <label htmlFor={this.button_id} class="dda-input-label">
              {this.label}
            </label>
          )}
          <div class="dda-search-area dda-search-action">
            <i class="material-icons icon-left" aria-hidden="true">
              search
            </i>
            <input
              name={this.search_input_name}
              aria-label={this.aria_label}
              id={this.input_id}
              value={this.internalValue || this.value}
              type="text"
              class={`dda-input-field dda-search-field ${this.show_button ? 'has-search-button' : ''}`}
              placeholder={this.placeholder}
              // onInput={this.handleInput}
              onKeyDown={this.handleKeyDown}
              onInput={event => {
                this.internalValue = (event.target as HTMLInputElement).value;
                this.inputChanged.emit(event);
              }}
              onBlur={event => {
                const value = (event.target as HTMLInputElement).value.trim();
                this.inputBlurred.emit({ name: this.search_input_name, value });
              }}
            />
            <div class="dda-search-btngroup">
              {this.hasInputValue && (
                <button
                  name={this.close_button_name}
                  aria-label={this.button_aria_label}
                  id={this.button_id}
                  type="button"
                  class="dda-search-close-icon"
                  onClick={() => this.clearInput()}
                >
                  <i class="material-icons material-symbols-outlined" aria-hidden="true">
                    close
                  </i>
                </button>
              )}
              {this.show_button && (
                <button name={this.search_button_name} type="button" class="dda-btn btn-color-default-primary dda-btn-sm" onClick={this.handleSearchClick}>
                  {this.button_text}
                </button>
              )}
            </div>
          </div>
          {this.helper_text && (
            <span class="dda-helper-text" id={this.validation_id}>
              {this.helper_text}
            </span>
          )}
          {this.error_message && (
            <span class="dda-error-message" id={this.validation_id}>
              {this.error_message}
            </span>
          )}
        </div>
      </Host>
    );
  }
}
